var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDashboardLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 13.5H14C13.7239 13.5 13.5 13.7239 13.5 14V19C13.5 19.2761 13.7239 19.5 14 19.5H19C19.2761 19.5 19.5 19.2761 19.5 19V14C19.5 13.7239 19.2761 13.5 19 13.5ZM14 12C12.8954 12 12 12.8954 12 14V19C12 20.1046 12.8954 21 14 21H19C20.1046 21 21 20.1046 21 19V14C21 12.8954 20.1046 12 19 12H14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 24.5H14C13.7239 24.5 13.5 24.7239 13.5 25V30C13.5 30.2761 13.7239 30.5 14 30.5H19C19.2761 30.5 19.5 30.2761 19.5 30V25C19.5 24.7239 19.2761 24.5 19 24.5ZM14 23C12.8954 23 12 23.8954 12 25V30C12 31.1046 12.8954 32 14 32H19C20.1046 32 21 31.1046 21 30V25C21 23.8954 20.1046 23 19 23H14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 13.5H25C24.7239 13.5 24.5 13.7239 24.5 14V19C24.5 19.2761 24.7239 19.5 25 19.5H30C30.2761 19.5 30.5 19.2761 30.5 19V14C30.5 13.7239 30.2761 13.5 30 13.5ZM25 12C23.8954 12 23 12.8954 23 14V19C23 20.1046 23.8954 21 25 21H30C31.1046 21 32 20.1046 32 19V14C32 12.8954 31.1046 12 30 12H25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 24.5H25C24.7239 24.5 24.5 24.7239 24.5 25V30C24.5 30.2761 24.7239 30.5 25 30.5H30C30.2761 30.5 30.5 30.2761 30.5 30V25C30.5 24.7239 30.2761 24.5 30 24.5ZM25 23C23.8954 23 23 23.8954 23 25V30C23 31.1046 23.8954 32 25 32H30C31.1046 32 32 31.1046 32 30V25C32 23.8954 31.1046 23 30 23H25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDashboardLight);
export default __webpack_public_path__ + "static/media/btn_dashboard_light.5589fcd68b1e518f8d19f2d845591f44.svg";
export { ForwardRef as ReactComponent };